module.exports = new __parcel__URL__("BrickFest.58de2f5c.jpeg").toString();